module.exports = __webpack_public_path__ + "img/backyard-pond-straight-on.b1156dbd.webp";